import type { SuperbillLocation } from '@/entities/client-billing-settings';
import type { PracticeLocation } from '@/entities/practice';

export type DisplayAddress =
    | { kind: 'ADD_LOCATION' }
    | { kind: SuperbillLocation; defaultLocationName: string };

export const getDisplayAddress = (
    locations: Pick<PracticeLocation, 'name' | 'isDefault'>[],
    storedLocation: SuperbillLocation,
): DisplayAddress => {
    const defaultLocation = locations.find((location) => location.isDefault);

    if (!defaultLocation) return { kind: 'ADD_LOCATION' };

    return { kind: storedLocation, defaultLocationName: defaultLocation.name };
};
